import React, { useState } from "react";
import "./Common_Product_Card.css";
import { useNavigate } from "react-router-dom";
import Product_Info_Grid_View from "../product_info_grid_view/Product_Info_Grid_View";

import Heart_icon from "../heart_icon/Heart_icon";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useDispatch, useSelector } from "react-redux";
import Select_Product_Cart_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";
import { encodeId } from "../../../utils/common";
const Common_Product_Card = ({
  button_color,
  background_color,
  product,
  ...props
}) => {
  const navigate = useNavigate();
  const [selectedVariant, setSelectedVariant] = useState({});
  const allCart = useSelector((state) => state.cart.allCarts);
  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const isSignin = useSelector((state) => state.auth.is_signin);
  const isIn = allCart?.data?.data?.some(
    (item) => item?.variant_id === selectedVariant?.id
  );

  return (
    <>
      {/* <section className='Common_Product_Card' onClick={() => { navigate(props?.goto) }} style={{ background: background_color }}>
                <div className={`outer_colored_card ${props?.theme_colour}`}>
                    <div className='img_holder'>
                        <img src={process.env.REACT_APP_IMG_URL + props?.prodImg} className='prod_img' />
                    </div>

                    <div className='text_holder' style={{ background: button_color }}>
                        <p className='prod_name'>{props?.prodName}</p>
                    </div>
                </div>
            </section> */}

      <div className="Product_Info_Grid_View_Section ">
        <div className="Product_Info_Grid_View">
          <div
            className="upper_image_section"
            onClick={() => navigate(`/product-description/${encodeId(product?.id)}`)}
          >
            <div className="card_img_holder">
              <img
                className=""
                src={process.env.REACT_APP_IMG_URL + props?.prodImg}
              />
            </div>

            <div className="overlay_text_holder">
              <div className="text_holder">
                <h5>
                  {" "}
                  {product?.Product_Variants[0]?.name} {product?.Unit?.name}
                </h5>
              </div>
              <div className="text_holder">
                <p>{product?.Product_Variants[0]?.pieces}</p>
              </div>
            </div>
          </div>

          <div className="lower_text_section">
            <p
              className="product_name"
              onClick={() => navigate(`/product-description/${encodeId(product?.id)}`)}
            >
              {props?.prodName}
            </p>

            <div className="pricing_div">
              <div className="left_side">
                <p className="selling_price">
                  ₹{product?.Product_Variants[0]?.price}
                </p>
                <p className="mrp">₹{product?.Product_Variants[0]?.mrp}</p>
                {/* <div className='discount_div'>
                                    <p className='discount'>{product?.discount}</p>
                                </div> */}
              </div>

              <div className="text-center btn_holder">
                {/* {!product?.outofStock ? ( */}
                <>
                  {/* {isIn ? (
                    <IncrementDecrementBtn
                      varientId={selectedVariant?.id}
                      cart={allCart?.data?.data}
                      productId={product?.id}
                      product={product}
                      isSignIn={isSignin}
                    />
                  ) : ( */}
                  <div className="">
                    <Green_Btn
                      btn_name="Add "
                      // leftIcon={faBasketShopping}
                      onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                      }}
                    />
                  </div>
              
                </>
              
              </div>
            </div>

            <Heart_icon product={product} />
          </div>

          <Select_Product_Cart_Modal
            varient={product?.Product_Variants}
            selectedVariant={selectedVariant}
            setSelectedVariant={setSelectedVariant}
            product={product}
            show={addcartmodal}
            onHide={() => Setaddcartmodal(false)}
          />
        </div>
      </div>
    </>
  );
};

export default Common_Product_Card;
